import { Box } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren<unknown> {
  small?: boolean;
}

export const StyledHead: FC<Props> = ({ children, small }) => {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey['50']}`,
        minHeight: {
          md: small ? '57px' : '80px',
          xs: '57px'
        },
        padding: '0px 24px 0px 24px'
      })}
    >
      {children}
    </Box>
  );
};
